import type WacUrlInfo from 'owa-attachment-wac/lib/types/WacUrlInfo';
import type { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';

export const tryProcessOneDriveLink = action(
    'tryProcessOneDriveLink',
    (element: HTMLElement, itemId: ClientItemId) => ({
        element,
        itemId,
    })
);

export const tryUndoProcessOneDriveLink = action(
    'tryUndoProcessOneDriveLink',
    (elements: HTMLElement[]) => ({
        elements,
    })
);

export const previewLinkInSxS = action(
    'previewLinkInSxS',
    (wacUrlGetter: () => Promise<WacUrlInfo>, itemId: ClientItemId, targetWindow: Window) => ({
        wacUrlGetter,
        itemId,
        targetWindow,
    })
);
